import global from '../utils/global.js'
import Page from './Page.js'
import DragScroll from "../components/DragScroll.js"

export default class GlobalPage extends Page {

    static instance

    constructor(parent) {

        if ( GlobalPage.instance ) return GlobalPage.instance
        super( 'global' )
        this.parent = parent
        GlobalPage.instance = this
        global.views.push( this.view )

    }   


}
